import { render } from "./form-login.vue?vue&type=template&id=1616631a&scoped=true"
import script from "./form-login.vue?vue&type=script&lang=js"
export * from "./form-login.vue?vue&type=script&lang=js"

import "./form-login.vue?vue&type=style&index=0&id=1616631a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1616631a"]])

export default __exports__